import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { uFormat } from 'types';
import { ValidationSeverity, ValidationError } from 'validation';
import { ValidationService } from './../validation/validation.service';
import { AppContext } from '../control/context';
import { FeaturesImpl } from '../model/features-impl';

class Item {
  validMessage: string = '';
}

@Component({
  selector: 'i-block-control',
  templateUrl: './block-control.component.html',
  styleUrls: ['./block-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockControlComponent implements OnInit, OnDestroy {
  @Input() inpExact: boolean = false;
  @Input() inpHideText: boolean = false;
  @Input() inpPath: string;

  validClass: string = '';
  items: Item[] = [];
  type: string = '';
  job: { total: string; error: number; break: string };

  private validationIndex: number;

  constructor(private appContext: AppContext, private validationService: ValidationService, private cdr: ChangeDetectorRef) {}

  private jobDate(json: string | null) {
    if (json === null) {
      return this.appContext.getI18NString('JOBNOW');
    }
    const dateObj = new Date(Date.parse(json));
    const dateStr = (dateObj.getFullYear() + '').padStart(4, '0') + '-' + (dateObj.getMonth() + 1 + '').padStart(2, '0') + '-00';
    return FeaturesImpl.formatMaskedDate(null, dateStr, this.appContext.getLocale());
  }

  ngOnInit() {
    const validationRegistration = this.validationService.register({
      path: this.inpPath,
      pathExact: this.inpExact,
      consumer: (final: boolean, errors: ValidationError[]) => {
        if (final) {
          let severity: ValidationSeverity | null = null;
          this.type = '';
          this.items = [];
          errors.forEach((v) => {
            if (
              v.severity === ValidationSeverity.ERROR ||
              (v.severity === ValidationSeverity.WARNING && severity !== ValidationSeverity.ERROR) ||
              (v.severity === ValidationSeverity.NOTIFICATION &&
                severity !== ValidationSeverity.ERROR &&
                severity !== ValidationSeverity.WARNING)
            ) {
              severity = v.severity;
            }
            if (v.message.startsWith('{')) {
              const obj = JSON.parse(v.message);
              if (obj.type === 'JOB') {
                this.type = obj.type;
                this.job = {
                  total: uFormat(this.appContext.getI18NString('JOBTOTAL'), obj.total / 12),
                  error: (obj.error * 360) / obj.total,
                  break: uFormat(this.appContext.getI18NString('JOBBREAK'), this.jobDate(obj.break.from), this.jobDate(obj.break.to)),
                };
              }
            } else {
              const item: Item = new Item();
              item.validMessage = v.message;
              this.items.push(item);
            }
          });
          this.validClass =
            errors.length === 0
              ? ''
              : errors[0].severity === ValidationSeverity.ERROR
              ? 'validation-error'
              : errors[0].severity === ValidationSeverity.WARNING
              ? 'validation-warning'
              : 'validation-notice';
          this.cdr.markForCheck();
        }
      },
    });
    this.validationIndex = validationRegistration.regKey;
  }

  ngOnDestroy() {
    this.validationService.unregister(this.validationIndex, false);
  }
}
